import { Tabs, Tab, Box } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

export default function HeaderRoutesWithUnderlining({ step = 0, steps = [] }) {
  const [value, setValue] = React.useState(step);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={value} onChange={(event, newValue) => setValue(newValue)}>
        {steps.map((item, index) => {
          if (item.hide) return null;

          return (
            <Tab
              key={index + 'tab'}
              label={item.label}
              component={item.disable ? 'div' : Link}
              to={item.disable ? undefined : item.link}
              disabled={item.disable}
              sx={{
                '&.Mui-selected': {
                  fontWeight: 700,
                },
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
}
